import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[divbackgroundimg]' })
export class DivbackgroundimgDirective {

    @Input() myUrl: string;
    // @Input() myHeight: number;


    constructor(private el: ElementRef) {
    }

    ngOnInit(){
    	this.myUrl = this.myUrl.replace(/ /g, '%20');
    	this.el.nativeElement.style.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3)),url(' + this.myUrl + ')';
    	this.el.nativeElement.style.backgroundRepeat = 'no-repeat';
    	this.el.nativeElement.style.backgroundSize = 'cover';
    	this.el.nativeElement.style.backgroundPosition = 'center';
    	this.el.nativeElement.style.paddingTop = '100%';
    	this.el.nativeElement.style.width = '100%';
    }
    
}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/directives/divbackgroundimg.directive.ts